import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppInsightsService } from '@experian-digital/affordability-library';
import { ApplicationInsightsEvents } from '@portal-shared/models/enums/appinsights-events.enum';

@Component({
  selector: 'aff-unauthorised',
  templateUrl: './unauthorised.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UnauthorisedComponent implements OnInit {
  ngOnInit(): void {
    AppInsightsService.logEvent(ApplicationInsightsEvents.UnauthorisedAccess);
  }
}
